import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
/*
  TODO: Codigo comentado hasta que se decida si se va usar el autocomplete

import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith, switchMap, debounceTime } from 'rxjs/operators';
import { ResultWells, Well } from '../../../interfaces/well';
import { WellService } from 'src/app/services/well.service';
import {
  LIMIT_SEARCH_WELL,
  OFFSSET_SEARCH_WELL,
  MIN_LENGTH_SEARCH,
} from 'src/app/handover-constants';
*/

@Component({
  selector: 'app-handover-initiate-well-search',
  templateUrl: './handover-initiate-well-search.component.html',
  styleUrls: ['./handover-initiate-well-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverInitiateWellSearchComponent implements OnInit {
  //wellControl = new FormControl();
  //filteredWells: Observable<Well[]> | undefined;
  toHighlight = '';
  totalWells = 0;
  textSearch = '';
  @Output() searchTextToEmit = new EventEmitter<string>();

  constructor(private router: Router, private route: ActivatedRoute) {
    if (
      this.router.getCurrentNavigation()?.extras.state?.textSearch !=
        undefined &&
      this.router.getCurrentNavigation()?.extras.state?.textSearch != null
    ) {
      this.textSearch =
        this.router.getCurrentNavigation()?.extras.state?.textSearch;
    }
  }

  ngOnInit(): void {
    if (this.textSearch.trim() == '') {
      this.textSearch = window.sessionStorage.getItem('textSearch') ?? '';
    }
    this.sendMessageToWellList(this.textSearch, true);
  }

  /*
  private filterWell(search: string): Observable<Well[]> {
    if (search && search.length >= MIN_LENGTH_SEARCH) {
      this.toHighlight = search;
      return this.wellService
        .getSearchWells(search, LIMIT_SEARCH_WELL, OFFSSET_SEARCH_WELL)
        .pipe(
          map((res: ResultWells) => {
            this.totalWells = res.totalWells;
            const wells: Well[] = res.wells;
            return wells;
          })
        );
    } else {
      return of([]);
    }
  }

  displayFn(well: Well): string {
    return well && well.wellCommonName ? well.wellCommonName : '';
  }
  */
  sendMessageToWellList(searchText: string, isOnInit: boolean): void {
    const searchQuery = this.route.snapshot.queryParamMap.get('search');
    if (searchQuery && isOnInit) {
      searchText = searchQuery;
      this.textSearch = searchQuery;
    } else if (searchText) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { search: searchText },
        queryParamsHandling: 'merge',
      });
    }
    window.sessionStorage.setItem('textSearch', searchText);
    this.searchTextToEmit.emit(searchText);
  }

  clearSessionSearchText(): void {
    window.sessionStorage.removeItem('textSearch');
  }
}
